/**
 * 어두운 화면(시작 · 골목 · 작별)이 떠 있는 동안 시스템 바 자리를 그 화면 색으로(DEV-13 0 · N-030).
 *
 * 앱의 웹뷰는 상태바 · 아래 바 사이에 들어가서 바 자리엔 창 바탕(크림)이 보여, 어두운 화면 위아래에 밝은 띠가 섰습니다.
 * 이 화면 동안만 창 바탕(AppChrome 플러그인, android AppChromePlugin.java) · body 를 먹색으로, 바 아이콘을 밝게 둡니다.
 * 웹에서는 body 바탕만 바뀌고 플러그인은 부르지 않습니다. iOS 는 바 아이콘 색(SystemBars)만 바꾸고 바 자리는 body 바탕이 칠합니다.
 */
import { useEffect } from 'react';
import { Capacitor, registerPlugin, SystemBars, SystemBarsStyle } from '@capacitor/core';

const AppChrome = registerPlugin('AppChrome');

// style.css 의 --color-text-primary · --color-bg 와 같은 색
const DARK = '#26231F';
const LIGHT = '#F6F1E7';

let holders = 0;

function setChrome(dark) {
    if (!Capacitor.isNativePlatform()) {
        return;
    }
    const fail = (error) => console.error('[bars] 바 색을 바꾸지 못함', error?.name);
    SystemBars.setStyle({ style: dark ? SystemBarsStyle.Dark : SystemBarsStyle.Light }).catch(fail);
    // 창 바탕 플러그인은 안드로이드에만 있습니다. iOS 는 웹뷰가 바 뒤까지 그려(contentInset never) body 바탕이 그 자리를 칠합니다(D108)
    if (Capacitor.getPlatform() === 'android') {
        // 예전 껍데기(플러그인 없음)면 조용히 실패
        AppChrome.setBackground({ color: dark ? DARK : LIGHT }).catch(fail);
    }
}

/**
 * 페이지가 뜰 때 한 번 밝은 화면 바(어두운 아이콘)로 맞춥니다(main.jsx).
 *
 * 바 색은 웹뷰가 아니라 기기 창의 상태라, 어두운 시작 화면에서 소셜 로그인 → 앱이 /auth/done 을 **새로 열면**(MainActivity ·
 * AppDelegate 의 loadUrl) 밝은 아이콘이 그대로 남았습니다. 새 페이지는 아직 아무도 어둡게 잡지 않았으니 밝게 되돌립니다.
 * 앱이 다시 앞으로 올 때도 지금 상태로 한 번 더 맞춥니다(다른 앱이 바 색을 바꿔 놓고 돌아오는 경우).
 */
export function initChrome() {
    setChrome(holders > 0);
    document.addEventListener('visibilitychange', () => {
        if (document.visibilityState === 'visible') {
            setChrome(holders > 0);
        }
    });
}

export function useDarkChrome() {
    useEffect(() => {
        holders += 1;
        document.body.dataset.chrome = 'dark';
        setChrome(true);
        return () => {
            holders -= 1;
            // 어두운 화면끼리 넘어갈 때(골목 → 카드) 밝게 깜빡이지 않게, 마지막 하나가 내려갈 때만 되돌림
            if (holders === 0) {
                delete document.body.dataset.chrome;
                setChrome(false);
            }
        };
    }, []);
}
